import * as React from 'react';
import * as styles from './navigation.css';
import { IUnderlineNavigationLink, UnderlineNavigation } from '../underline_navigation';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { SharingButtonContainer } from './sharing_button/container';
import { FavoriteButtonContainer } from './favorite_button/container';

export interface INavigation {
  isActive: boolean;
  isInTransition: boolean;
  links: IUnderlineNavigationLink[];
  activeHref: string;
  description: string;
  showRightContent: boolean;
  isFixed: boolean;

  navigate(event: React.MouseEvent<HTMLAnchorElement>, href: string): void;
}

export const Navigation = (props: INavigation) => {
  const { isActive, isInTransition, links, activeHref, navigate, description, showRightContent, isFixed } = props;

  return (
    <div
      {...mergeStyles(
        styles['navigation'],
        (isFixed && styles['navigation--fixed']) || styles['navigation--static'],
        isFixed && isActive && styles['navigation--active'],
        isFixed && isInTransition && styles['navigation--transition'],
      )}
      data-navigation-type={isFixed ? 'fixed' : 'static'}
    >
      <div className={styles['wrapper']}>
        <UnderlineNavigation
          className={styles['underline']}
          links={links}
          activeHref={activeHref}
          navigate={navigate}
        />

        {showRightContent && (
          <div className={styles['aside']}>
            <div className={styles['description']}>{description}</div>
            <div className={styles['aside-buttons']}>
              <FavoriteButtonContainer />
              <SharingButtonContainer />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
